import MDIGITAL_CONFIGURATION from "../modules/MDIGITAL_CONFIGURATION";
import KAMPYLE_CONSTANT from "../modules/KAMPYLE_CONSTANT";
import KAMPYLE_FUNC from "../modules/KAMPYLE_FUNC";
import KAMPYLE_UTILS from "../modules/KAMPYLE_UTILS";
import KAMPYLE_EVENT_DISPATCHER from "../modules/KAMPYLE_EVENT_DISPATCHER";
import MDIGITAL_ANALYTICS from '../modules/MDIGITAL_ANALYTICS';

  var eventQueue = [];
  var numAttempts = 0;

  var CONFIG = {
    POLLING_INTERVAL: 5000,
    POLLING_COUNTER: 3
  };

  var COMMON_FIELDS = {
    CONTEXT_NAME: 'NebulaCX_Activity'
  };

  var events = {
    'neb_formShown': {
      action: 'form_displayed'
    },
    'neb_showInvitation': {
      action: 'invite_triggered'
    },
    'neb_inviteDeclined': {
      action: 'invite_rejected'
    },
    'neb_inviteAccepted': {
      action: 'invite_accepted'
    },
    'neb_buttonClicked': {
      action: 'button_clicked'
    },
    'neb_feedbackSubmitted': {
      action: 'feedback_submitted'
    },
    'neb_feedbackPostSubmitted': {
      action: 'feedback_submitted'
    },
    'neb_formClosed': {
      action: 'form_close'
    },
    'neb_formPageShown': {
      action: 'form_page_displayed'
    },
    'neb_captureInit': {
      action: 'screen_capture_init'
    },
    'neb_captureImageClicked': {
      action: 'capture_image_click'
    },
    'neb_cancelCaptureClicked': {
      action: 'cancel_capture_click'
    },
    'MDigital_Form_Close_No_Submit': {
      action: 'form_close_no_submit'
    },
    'MDigital_Form_Next_Page': {
      action: 'form_next_page'
    },
    'MDigital_Form_Back_Page': {
      action: 'form_back_page'
    },
    'MDigital_ThankYou_Displayed': {
      action: 'thankyou_displayed'
    },
    'MDigital_ThankYou_Close': {
      action: 'thankyou_close'
    },
    'MDigital_Form_Close_Submitted': {
      action: 'form_close_submit'
    },
    'neb_sdkShowForm': {
      action: 'form_triggered_by_code'
    }
  };

  var adobeSdkName;

  var sendAAEvent = function(eventName, data) {
    var action = !!events[eventName] && !!events[eventName].action ? events[eventName].action : undefined;

    var processedData = processDataForAA(data);

    if (!!window[adobeSdkName] && !!window[adobeSdkName].tl){
      //NM-5710
      //On some Vodafone accounts the adobe object doesnt have contextData property
      KAMPYLE_UTILS.setNestedPropertyValue(
        window,
        getPropString(adobeSdkName,'contextData','eventName'),
        action
      );
      var isAdobeLinkTrackVarsProvisionOn = KAMPYLE_FUNC.checkProvision(
        KAMPYLE_CONSTANT.PROVISIONS.ADOBE_INCLUDE_LINK_TRACK_VARS
      );
      var isAdobeConcatLinkTrackVarsProvisionOn = KAMPYLE_FUNC.checkProvision(
        KAMPYLE_CONSTANT.PROVISIONS.ADOBE_CONCAT_LINK_TRACK_VARS
      );
      var contextEventName = 'contextData.eventName';
      if (isAdobeLinkTrackVarsProvisionOn) {
        window[adobeSdkName].linkTrackVars =
          window[adobeSdkName].linkTrackVars && isAdobeConcatLinkTrackVarsProvisionOn
            ? window[adobeSdkName].linkTrackVars
                .split(',')
                .concat(
                  window[adobeSdkName].linkTrackVars.indexOf(contextEventName) < 0
                    ? [ contextEventName ]
                    : []
                )
            : [ contextEventName ];
      }
      for (var key in processedData) {
        if (processedData.hasOwnProperty(key) && !KAMPYLE_CONSTANT.ANALYTICS_EVENT_FORBIDDEN_PROPERTIES[key]) {
          //NM 5710
          KAMPYLE_UTILS.setNestedPropertyValue(
            window,
            getPropString(adobeSdkName, 'contextData', key),
            processedData[key]
          ); //
          if (
            isAdobeLinkTrackVarsProvisionOn &&
            window[adobeSdkName].linkTrackVars.indexOf('contextData.' + key) < 0
          ) {
            window[adobeSdkName].linkTrackVars.push('contextData.' + key);
          }
        }
      }
      if (isAdobeLinkTrackVarsProvisionOn) {
        window[adobeSdkName].linkTrackVars = window[adobeSdkName].linkTrackVars.join(',');
      }
      window[adobeSdkName].tl(this, 'o', COMMON_FIELDS.CONTEXT_NAME);
    }
  };

  function processDataForAA(data) {
    var processedData = Object.assign({}, data);

    if (Array.isArray(processedData.content)) {
      for (var i = 0; i < processedData.content.length; i++) {
        processedData[processedData.content[i].unique_name] = processedData.content[i].value;
      }
    }
    return processedData;
  }

  var dequeueEvents = function(eventName, data) {
    if (!window[adobeSdkName] || !window[adobeSdkName].tl) {
      //Meaning Adobe Analytics hasn't been loaded yet
      numAttempts++;
      if (numAttempts < CONFIG.POLLING_COUNTER) {
        window.setTimeout(dequeueEvents, CONFIG.POLLING_INTERVAL);
      }
    } else {
      //ga exists
      var queueLen = eventQueue.length;
      for (var i = 0; i < queueLen; i++) {
        try {
          sendAAEvent(eventQueue[i].eventName, eventQueue[i].data);
        } catch (e) {
          var error = {
            errorMessage: e.message,
            errorStack: e.stack,
            additionalInfo: 'KAMPYLE_ADOBE_ANALYTICS'
          };
          var event = KAMPYLE_CONSTANT.EVENTS.NEB_EVENT_DISPATCHER_ERROR;
          if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
            MDIGITAL_ANALYTICS.triggerDigitalEvent(event, error);
          }
        }
      }

      //Reset queue
      numAttempts = 0;
      eventQueue = [];
    }
  };

  var triggerEvent = function(eventName, data) {
    eventQueue = eventQueue || [];

    if (!!eventName && !!data) {
      eventQueue.push({
        eventName: eventName,
        data: data
      });
    }
    dequeueEvents();
  };

  function init() {
    adobeSdkName = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ADOBE_ANALYTICS_OBJECT_NAME)
      ? getAdobeSdkName()
      : KAMPYLE_CONSTANT.DEFAULT_ADOBE_SDK_NAME;

    for (var prop in events) {
      KAMPYLE_EVENT_DISPATCHER.subscribe(prop, triggerEvent);
    }

    return true;
  }

  function getAdobeSdkName() {
    return (
      KAMPYLE_UTILS.getNestedPropertyValue(MDIGITAL_CONFIGURATION.getOnsiteConfiguration(), 'adobeSdkName') ||
      KAMPYLE_CONSTANT.DEFAULT_ADOBE_SDK_NAME
    );
  }

  function getPropString() {
    return Array.prototype.join.call(arguments, '.');
  }

  export default {
    init: init,
    triggerEvent: triggerEvent,
    getAdobeSdkName: getAdobeSdkName,
    sendAAEvent: sendAAEvent, //for tests
    processDataForAA: processDataForAA //for tests
  };
